// src/admin/Dashboard.js
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase';
import { Package, FolderTree, ShoppingBag, Users, TrendingUp, BarChart3 } from 'lucide-react';

const Dashboard = () => {
  const [stats, setStats] = useState({ products: 0, categories: 0, orders: 0, customers: 0 });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const [productsSnap, categoriesSnap, ordersSnap, usersSnap] = await Promise.all([
          getDocs(collection(db, 'products')),
          getDocs(collection(db, 'categories')),
          getDocs(collection(db, 'orders')),
          getDocs(collection(db, 'users')),
        ]);

        setStats({
          products: productsSnap.size,
          categories: categoriesSnap.size,
          orders: ordersSnap.size,
          customers: usersSnap.size,
        });
      } catch (error) {
        console.error('Error fetching stats:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchStats();
  }, []);

  const statCards = [
    { label: 'Total Products', value: stats.products, icon: Package, link: '/admin/products' },
    { label: 'Categories', value: stats.categories, icon: FolderTree, link: '/admin/categories' },
    { label: 'Orders', value: stats.orders, icon: ShoppingBag, link: '/admin/orders' },
    { label: 'Customers', value: stats.customers, icon: Users, link: '/admin/customers' },
  ];

  return (
    <div className="space-y-6">

      {/* Welcome Banner - PINK GRADIENT */}
      <div
        className="rounded-xl p-6 text-white shadow-lg"
        style={{
          background: `linear-gradient(135deg, var(--color-button-bg) 0%, var(--color-button-hover-bg) 100%)`,
        }}
      >
        <div className="flex items-center gap-3">
          <TrendingUp size={32} />
          <div>
            <h1 className="text-2xl font-bold">Welcome to Admin Panel</h1>
            <p className="text-sm mt-1 opacity-90">Manage your store from here.</p>
          </div>
        </div>
      </div>

      {/* Stats Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {statCards.map((stat) => {
          const Icon = stat.icon;
          return (
            <Link key={stat.label} to={stat.link}
              className="bg-white rounded-xl shadow-md p-5 hover:shadow-lg transition block">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-gray-500 text-sm font-medium">{stat.label}</p>
                  <p className="text-3xl font-bold text-gray-800 mt-1">{loading ? '...' : stat.value}</p>
                </div>
                <div
                  className="rounded-full p-3 text-white"
                  style={{ backgroundColor: 'var(--color-button-bg)' }}
                >
                  <Icon size={24} />
                </div>
              </div>
            </Link>
          );
        })}
      </div>

      {/* Quick Actions */}
      <div className="bg-white rounded-xl shadow-md p-6">
        <h2 className="text-lg font-bold text-gray-800 mb-4">Quick Actions</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
          <Link to="/admin/analytics"
            className="font-semibold py-3 px-4 rounded-lg text-center transition hover:opacity-90 flex items-center justify-center gap-2"
            style={{ backgroundColor: '#FFF2F6', color: 'var(--color-link)' }}>
            <BarChart3 size={16} /> View Analytics
          </Link>
          <Link to="/admin/products"
            className="font-semibold py-3 px-4 rounded-lg text-center transition hover:opacity-90"
            style={{ backgroundColor: '#FFF2F6', color: 'var(--color-link)' }}>
            + Add Product
          </Link>
          <Link to="/admin/categories"
            className="font-semibold py-3 px-4 rounded-lg text-center transition hover:opacity-90"
            style={{ backgroundColor: '#FFF2F6', color: 'var(--color-link)' }}>
            + Add Category
          </Link>
          <Link to="/admin/orders"
            className="font-semibold py-3 px-4 rounded-lg text-center transition hover:opacity-90"
            style={{ backgroundColor: '#FFF2F6', color: 'var(--color-link)' }}>
            View Orders
          </Link>
        </div>
      </div>

    </div>
  );
};

export default Dashboard;